/**
 * API Client für die Mietwerkstatt Frontend Anwendung
 * Konfiguriert und exportiert eine Instanz des MietwerkstattApiClient
 */

import { MietwerkstattApiClient } from "../types/api-client";
import { getApiBaseUrl, getEnvironmentInfo } from "../utils/environment";

// API Base URL über Environment Utilities
const API_BASE_URL = getApiBaseUrl();

console.log("🌐 Initializing API client with base URL:", API_BASE_URL);
console.log("🌍 Environment Info:", getEnvironmentInfo());

// Erstelle und konfiguriere API Client
export const apiClient = new MietwerkstattApiClient(API_BASE_URL);

// Token Management - Erweitert um Refresh Token
export const setAuthTokens = (accessToken: string, refreshToken: string) => {
  console.log(
    "🔑 Setting auth tokens:",
    accessToken ? "Access token set" : "No access token",
    refreshToken ? "Refresh token set" : "No refresh token"
  );
  apiClient.setAccessToken(accessToken);
  localStorage.setItem("accessToken", accessToken);
  if (refreshToken) {
    apiClient.setRefreshToken(refreshToken);
    localStorage.setItem("refreshToken", refreshToken);
  }
  console.log("💾 Tokens saved to localStorage");
  // Sofortige Verifikation
  console.log(
    "🔍 Verification - API Client tokens:",
    (apiClient as any).accessToken ? "ACCESS SET" : "ACCESS NOT SET",
    (apiClient as any).refreshToken ? "REFRESH SET" : "REFRESH NOT SET"
  );
};

export const setAuthToken = (token: string) => {
  console.log(
    "🔑 Setting auth token:",
    token ? "Token set" : "No token"
  );
  apiClient.setAccessToken(token);
  localStorage.setItem("accessToken", token); // Verwende 'accessToken' statt 'authToken'
  console.log("💾 Token saved to localStorage");
  // Sofortige Verifikation
  console.log(
    "🔍 Verification - API Client token:",
    (apiClient as any).accessToken ? "GESETZT" : "NICHT GESETZT"
  );
};

export const getAuthToken = (): string | null => {
  const token = localStorage.getItem("accessToken"); // Verwende 'accessToken' statt 'authToken'
  console.log(
    "🔍 Getting auth token from localStorage:",
    token ? "Token found" : "No token found"
  );
  return token;
};

export const getRefreshToken = (): string | null => {
  const token = localStorage.getItem("refreshToken");
  console.log(
    "🔍 Getting refresh token from localStorage:",
    token ? "Token found" : "No token found"
  );
  return token;
};

export const clearAuthToken = () => {
  console.log("🗑️ Clearing auth tokens");
  apiClient.clearToken();
  localStorage.removeItem("accessToken"); // Verwende 'accessToken' statt 'authToken'
  localStorage.removeItem("refreshToken");
  console.log("🧹 Tokens removed from localStorage");
};

// Funktion um Token bei Bedarf zu initialisieren
export const ensureTokenIsSet = () => {
  const savedToken = getAuthToken();
  const savedRefreshToken = getRefreshToken();
  if (savedToken && !(apiClient as any).accessToken) {
    console.log(
      "🔄 Token found in localStorage but not in API client - setting now"
    );
    apiClient.setAccessToken(savedToken);
    if (savedRefreshToken) {
      apiClient.setRefreshToken(savedRefreshToken);
    }
    console.log("✅ Tokens set in API client");
  } else if (savedToken && (apiClient as any).accessToken) {
    console.log("✅ Tokens already set in API client");
  } else {
    console.log("⚠️ No tokens available");
  }
  return !!(apiClient as any).accessToken;
};

// Automatischer Token Refresh
export const refreshAuthToken = async (): Promise<boolean> => {
  const refreshToken = getRefreshToken();
  if (!refreshToken) {
    console.log("❌ No refresh token available");
    return false;
  }

  try {
    console.log("🔄 Attempting to refresh access token...");
    const response = await apiClient.refreshToken({ refreshToken });
    console.log("✅ Token refresh successful");

    // Neue Tokens speichern
    setAuthTokens(response.tokens.accessToken, response.tokens.refreshToken);
    return true;
  } catch (error) {
    console.error("❌ Token refresh failed:", error);
    clearAuthToken();
    return false;
  }
};

// Sofortige Initialisierung
const initializeToken = () => {
  console.log("🚀 Initializing API client tokens...");
  ensureTokenIsSet();
};

// Mehrere Initialisierungsversuche
initializeToken(); // Sofort
setTimeout(initializeToken, 50); // Nach 50ms
setTimeout(initializeToken, 200); // Nach 200ms

export default apiClient;
